import { fieldsOf } from 'constants/kpiBuilderCatalogue';
import { groupById, rateCandidates } from 'helpers/kpiBuilder/learnerGroups';
import { BuilderSection } from './BuilderSection';
import { FilterRow } from './FilterRow';
import { OptionCards } from './OptionCards';
import { StepProps } from './StepProps';
import { TextBox } from './TextBox';

interface TraitStepProps extends StepProps {
  title: string;
  hint: string;
}

/** Groups that fit, plus the saved one, so a saved choice is never hidden by the other ticks. */
const candidatesWithSaved = (a: StepProps['a']) => {
  const cards = rateCandidates(a).map((g) => ({ id: g.id, label: g.label, desc: g.rule }));
  const saved = groupById(a.rateSeg ?? '');
  return saved && !cards.some((c) => c.id === saved.id) ? [...cards, { id: saved.id, label: saved.label, desc: saved.rule }] : cards;
};

const CUSTOM_CARD = { id: 'custom', label: 'Another condition…', desc: 'Describe it yourself with any field, for example “attempt number is more than 1”.' };

// Choose the trait to measure or compare: a saved learner group, or a condition you describe.
export const TraitStep = ({ a, patch, title, hint }: TraitStepProps) => (
  <BuilderSection title={title} hint={hint}>
    <OptionCards cards={[...candidatesWithSaved(a), CUSTOM_CARD]} selected={a.rateSeg ? [a.rateSeg] : []} onSelect={(id) => patch({ rateSeg: id })} />
    {a.rateSeg === 'custom' && (
      <div className="border rounded p-3 mt-3 bg-white">
        <FilterRow filter={a.custom.rateWhen} fields={fieldsOf(a.src)} onChange={(rateWhen) => patch({ custom: { ...a.custom, rateWhen } })} />
        <TextBox value={a.custom.rateLabel} placeholder="Name shown on the chart, e.g. Reattempted" onChange={(rateLabel) => patch({ custom: { ...a.custom, rateLabel } })} />
      </div>
    )}
  </BuilderSection>
);
